module.exports = __webpack_public_path__ + "img/radni_nalog.b8eb535f.png";